import { actions } from './action'

const initialState = {
  payRollpagination: {
    skip: 0,
    limit: 10,
  },
  empPayrollList: {},
  payrollData: null,
  loading: false,
  error: null,
  employeesList: [],
  employeesPayrollList: [],
  totalCount: 0,
  payrollShareStatus: null,
}
const payrollState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_EMP_PAYROLL_LIST:
      return {
        ...state,
        empPayrollList: action.payload,
      }
    case actions.HANDLE_PAYROLL_PAGINATION:
      return {
        ...state,
        payRollpagination: action.payload,
      }
    case actions.TOGGLE_LOADING_PAYROLL:
      return {
        ...state,
        loading: action.payload,
      }
    case actions.FETCH_PAYROLL_DATA:
      return { ...state, payrollData: action.payload }
    case actions.EMPLOYEE_LIST_WITH_PAYROLL:
      return {
        ...state,
        employeesList: action.payload?.employees,
        totalCount: action.payload?.totalCount,
      }
    case actions.EMPLOYEE_LIST_WITH_PAYROLL_DATA:
      return {
        ...state,
        employeesPayrollList: action.payload,
      }
    case actions.SHARE_PAYROLL_BY_MONTH_YEAR:
      return {
        ...state,
        payrollShareStatus: action.payload, // Store the shared payroll data/status here
      }
    default:
      return state
  }
}
export default payrollState
